import styled from "styled-components";

export const Tag = styled.div`
    padding: .25rem 1rem;
    border-radius: 1rem;
    width: fit-content;
    font-size: .8rem;
    font-weight: bold;
    background: ${props => props.color || 'var(--success)'}
`;